import { render, staticRenderFns } from "./PrSplitLeft.vue?vue&type=template&id=2c8e95d0&"
import script from "./PrSplitLeft.vue?vue&type=script&lang=js&"
export * from "./PrSplitLeft.vue?vue&type=script&lang=js&"
import style0 from "./PrSplitLeft.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports